import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
} from "@mui/material";
import { Delete, Add, SignalCellularConnectedNoInternet0BarSharp } from "@mui/icons-material";
import apiClient from "./api/apiClient";

const UserMaintenance = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("ACTIVE");

  const [pinsCovered, setPinsCovered] = useState([]);
  const [pinsExcluded, setPinsExcluded] = useState([]);
  const [roles, setRoles] = useState([]); // For dropdown options
  const [selectedRole, setSelectedRole] = useState(""); // For selected value
  const [reportingManagers,setReportingManagers] = useState([]);
  const [selectedReportingManager, setSelectedReportingManager] = useState(""); // For selected value  
  const [selectedTlFe,setSelectedTlFe] = useState("")
  useEffect(() => {
    fetchAllRoles();
    fetchReportingManagers();
    if (userId) {
      fetchUserDetails();
    } else {
      setEmail("");
      setName("");
      setStatus("Active");
    }
  }, [userId]);

  const fetchReportingManagers = async()=>{
    try{
      let response = await apiClient.get(`/users`);
      setReportingManagers(response.data);
    }catch(error){
      console.log("Error reading reporting managers");
    }
  }
  const fetchAllRoles = async()=>{
    try{
      let response = await apiClient.get(`/roles`);
      setRoles(response.data);
    }catch(error){
      console.log("Error reading roles")
    }
  }
  const fetchUserDetails = async()=>{
    try{
      let response = await apiClient.get(`/users/${userId}`);
      setEmail(response.data.email);
      setName(response.data.name);
      setStatus(response.data.status);
      setSelectedRole(response.data.roleId);
      setSelectedReportingManager(response.data.reportingManager);
      setSelectedTlFe(response.data.tlFe);

      let pinsCoveredResponse = await apiClient.get(`/userpinscovered/user/${userId}`);
      setPinsCovered(pinsCoveredResponse.data);

      let pinsExcludedResponse = await apiClient.get(`/userpinsexcluded/user/${userId}`);
      setPinsExcluded(pinsExcludedResponse.data);      
    }catch(error){
      console.log("Error fetching user details");
    }
  }
  const handleSave = async()=>{
    if(userId){
      try{
        let response = apiClient.put(`/users/update/${userId}`,{name:name,email:email,status:status,reportingManager:selectedReportingManager,roleId:selectedRole,tlFe:selectedTlFe,pinsCovered:pinsCovered,pinsExcluded:pinsExcluded});
        navigate("/users")
      }catch(error){
        console.log("Error saving user details")
      }
    }else{
      try{
        console.log("About to post the values")
        let response = apiClient.post(`/users/create`,{name:name,email:email,status:status,reportingManager:selectedReportingManager,roleId:selectedRole,tlFe:selectedTlFe,pinsCovered:pinsCovered,pinsExcluded:pinsExcluded});
        navigate("/users")
      }catch(error){
        console.log("Error saving user details")
      }

    }
  }
  const handleDeleteRow = (table, index) => {
    if (table === "covered") {
      setPinsCovered(pinsCovered.filter((_, i) => i !== index));
    } else {
      setPinsExcluded(pinsExcluded.filter((_, i) => i !== index));
    }
  };

  const handleAddRow = (table) => {
    if (table === "covered") {
      setPinsCovered([...pinsCovered, { from: "", to: "" }]);
    } else {
      setPinsExcluded([...pinsExcluded, { from: "", to: "" }]);
    }
  };

  return (
    <Box sx={{ width: "90%", margin: "auto", mt: 5 }}>
      <Typography variant="h5" sx={{ mb: 3, textAlign: "center", fontWeight: 'bold' }}>
        {userId ? "Edit User" : "Add User"}
      </Typography>      
      {/* User Details Row */}
      <Box sx={{ display: "flex", gap: 2 }}>
      <TextField label="Name" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
        <TextField label="Email ID" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
        <FormControl fullWidth>
          <InputLabel>Status</InputLabel>
          <Select value={status} onChange={(e) => setStatus(e.target.value)} label="Status" >
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
        </Box>
        <Box sx={{ display: "flex", gap: 2,mt: 2 }}>
        <FormControl fullWidth>
          <InputLabel>Role</InputLabel>
          <Select value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)} label="Role">
            {roles.map((role, index) => (
              <MenuItem key={index} value={role.id}>
                {role.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>Reporting To</InputLabel>
          <Select value={selectedReportingManager} onChange={(e) => setSelectedReportingManager(e.target.value)} label="Reporting To">
            {reportingManagers.map((user, index) => (
              <MenuItem key={index} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>   
        <FormControl fullWidth>
          <InputLabel>Is TL-FE</InputLabel>
          <Select value={selectedTlFe} onChange={(e) => setSelectedTlFe(e.target.value)} label="Is TL-FE">
              <MenuItem value="NO">NO</MenuItem>
              <MenuItem value="YES">YES</MenuItem>
          </Select>
        </FormControl>                
      </Box>

      {/* Tables Section */}
      <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
        {/* PINs Covered Table */}
        <Box sx={{ flex: 1 }}>
          <Typography  variant="h6" sx={{ mb: 1,alignSelf:'center' }}>
            PINs Covered
          </Typography>
          <Button
            startIcon={<Add />}
            variant="contained"
            size="small"
            sx={{ mb: 1 }}
            onClick={() => handleAddRow("covered")}
          >
            Add Row
          </Button>
          <TableContainer  component={Paper}  sx={{ maxHeight: 250,    height: 200,    border: '1px solid #ccc',overflowY: 'auto',}}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>From</TableCell>
                  <TableCell>To</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pinsCovered.map((row, index) => (
                  <TableRow key={index} sx={{ '& td': { py: 0.2, px: 1 } }}>
                <TableCell sx={{ width: "40%" }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={row.fromPin}
                    fullWidth
                    InputProps={{ sx: { height: 30 } }}
                    onChange={(e) => {
                      const updatedPins = [...pinsCovered];
                      updatedPins[index].fromPin = e.target.value;
                      setPinsCovered(updatedPins);
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "40%" }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={row.toPin}
                    fullWidth
                    InputProps={{ sx: { height: 30 } }}
                    onChange={(e) => {
                      const updatedPins = [...pinsCovered];
                      updatedPins[index].toPin = e.target.value;
                      setPinsCovered(updatedPins);
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "20%", textAlign: "center" }}>
                  <IconButton color="error" onClick={() => handleDeleteRow("covered", index)} size="small">
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        {/* PINs Excluded Table */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            PINs Excluded
          </Typography>
          <Button
            startIcon={<Add />}
            variant="contained"
            size="small"
            sx={{ mb: 1 }}
            onClick={() => handleAddRow("excluded")}
          >
            Add Row
          </Button>
          <TableContainer  component={Paper}  sx={{ maxHeight: 250,    height: 200,    border: '1px solid #ccc',overflowY: 'auto',}}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>From</TableCell>
                  <TableCell>To</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pinsExcluded.map((row, index) => (
                  <TableRow key={index} sx={{ '& td': { py: 0.2, px: 1 } }}>
                <TableCell sx={{ width: "40%" }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={row.fromPin}
                    fullWidth
                    InputProps={{ sx: { height: 30 } }}
                    onChange={(e) => {
                      const updatedPins = [...pinsExcluded];
                      updatedPins[index].fromPin = e.target.value;
                      setPinsExcluded(updatedPins);
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "40%" }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    value={row.toPin}
                    fullWidth
                    InputProps={{ sx: { height: 30 } }}
                    onChange={(e) => {
                      const updatedPins = [...pinsExcluded];
                      updatedPins[index].toPin = e.target.value;
                      setPinsExcluded(updatedPins);
                    }}
                  />
                </TableCell>
                <TableCell sx={{ width: "20%", textAlign: "center" }}>
                  <IconButton color="error" onClick={() => handleDeleteRow("excluded", index)} size="small">
                    <Delete fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>

                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>

      {/* Buttons Section */}
      <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save User
        </Button>
        <Button variant="outlined" color="secondary" onClick={() => navigate("/users")}>
          Go Back
        </Button>
      </Box>
    </Box>
  );
};

export default UserMaintenance;
